// @ts-nocheck
import React from 'react';

import OnlineSolutionButtonView from '../../Components/OnlineSolutionButton';
import {
  CLEAR_PLUS_TABS,
  useClearPlusByOnDemand,
} from '../../Contexts/ClearPlusByOnDemandProvider';

function OnlineSolutionButton({ onlineSolutionButtonProps }) {
  const { onOpenDrawer, isClearByOnDemand, setActiveTab } = useClearPlusByOnDemand();

  if (!isClearByOnDemand) return null;

  const handleOpenDrawer = () => {
    onOpenDrawer();
    setActiveTab(CLEAR_PLUS_TABS.ONLINE_SOLUTION);
  };

  return <OnlineSolutionButtonView onClick={handleOpenDrawer} {...onlineSolutionButtonProps} />;
}

export default OnlineSolutionButton;
